import { format } from "date-fns";

const API = process.env.REACT_APP_API_ENDPOINT;

// ricorda di ripassare API ALLA FINE ${API}

export const service = {
  loginTools: async (data) => {
    const response = await fetch(`${API}api/token-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Login fallito.");
    }

    return await response.json();
  },

  getUser: async (token) => {
    const response = await fetch(`${API}api/user`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  getAllUsers: async (token) => {
    const response = await fetch(`${API}api/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  getDocuments: async (token, filters = {}) => {
    const response = await fetch(`${API}api/documents/filter`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        year: filters.year || "",
        month: filters.month || "",
        reader_id: filters.reader_id || "",
        per_page: filters.per_page || "",
        page: filters.page || 1,
        ...(filters.subject_reader_id
          ? { subject_reader_id: filters.subject_reader_id }
          : {}),
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  uploadDocument: async (token, document) => {
    const formData = new FormData();

    formData.append("reader_id", document.reader.id);

    if (document.datario) {
      formData.append(
        "datario",
        format(new Date(document.datario), "yyyy-MM-dd"),
      );
    }

    if (document.files?.length) {
      formData.append("file", document.files[0]);
    }

    if (document.subject_reader_id) {
      formData.append("subject_reader_id", document.subject_reader_id);
    }

    const response = await fetch(`${API}api/documents`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text);
    }

    return response.json();
  },

  replaceDocument: async (token, document) => {
    const formData = new FormData();

    formData.append("reader_id", document.reader.id);

    if (document.datario) {
      formData.append(
        "datario",
        format(new Date(document.datario), "yyyy-MM-dd"),
      );
    }

    if (document.files?.length) {
      formData.append("file", document.files[0]);
    }

    if (document.subject_reader_id) {
      formData.append("subject_reader_id", document.subject_reader_id);
    }

    const response = await fetch(`${API}api/documents/${document.id}/replace`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text);
    }

    return response.json();
  },

  deleteDocument: async (token, id) => {
    const response = await fetch(`${API}api/documents/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return await response.json();
  },

  downlaodDocument: async (token, id) => {
    const response = await fetch(`${API}api/documents/${id}/download`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }

    return response.blob();
  },

  logout: async (token) => {
    const response = await fetch(`${API}api/logout`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Logout fallito.");
    }

    return await response.json();
  },
};
